import React, { useState } from 'react';
import { addSeconds, format } from 'date-fns';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AiFillLock } from 'react-icons/ai';
import Accordion from '../Accordion';
import BackArrow from '../BackArrow';
import ClassesLengthBadge from '../ClassesLengthBadge';
import ClassProgress from '../ClassesProgress';
import { RootState } from '../../store';
import { ModulesI } from '../../types/Class';
import FreeUserModal from '../FreeUserModal';
import freeUserRedirectLinks from '../../utils/freeUserRedirectLinks';
import { setIdClass } from '../../store/Classes.store';
import {
  Container,
  Content,
  Cover,
  Description,
  Info,
  AccordionContainer, ContentImage, ListContainer, Thumb, ContainerImgThumb,
} from './styles';
import icoCheck1 from '../../assets/Training/check_circle1.svg';
import icoCheck2 from '../../assets/Training/check_circle2.svg';
import theme from '../../theme';
import hiddenClassesBasic from '../ClassesList/hiddenClassesBasic';
import api from '../../services/api';

function ClassesCover() {
  const currentClass = useSelector((state: RootState) => state.classes.currentClass);
  const user = useSelector((state: RootState) => state.auth.user);
  const isBasic = user.subscription_type === 'BASIC';

  const { isFree } = user;
  const [freeModal, setFreeModal] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { subscription } = useSelector((state: RootState) => state.subscription);
  const isSubscriptionAfterRuleDate = subscription ? (isBasic && new Date(subscription?.start_at) > new Date('2025-05-12')) : true;

  const {
    name,
    cover,
    description,
    executed_percent,
    courseModules,
    internal_name,
  } = currentClass!;

  const freeClasses = [
    'Orientações iniciais importantes',
    'A postura na corrida',
    'Princípio do desequilíbrio',
    'A passada na corrida',
  ];

  const callRd = async (conversion: string) => {
    try {
      await api.post('conversion_app', { conversion });
    } catch (error) {
      //
    }
  };

  const openClass = (activitie: ModulesI) => {
    const isBlockForFree = !freeClasses.includes(activitie.name);
    if (isFree && isBlockForFree) {
      setFreeModal(true);
      return;
    }
    if (isSubscriptionAfterRuleDate && hiddenClassesBasic.includes(internal_name)) {
      // open paywall - to do
      const conversion = `basic-open-${internal_name}`;
      callRd(conversion);
      return;
    }
    navigate('/club/ClassExecution');
    dispatch(setIdClass(activitie.id));
  };

  return (
    <Container>
      <BackArrow text={name?.toUpperCase()} bigger backTo="/club/exclusive-classes" />
      <FreeUserModal
        isModalOpen
        isVisible={freeModal}
        text="Esta série de aulas está disponível apenas para membros do Corrida Perfeita."
        link={freeUserRedirectLinks.classes}
        toggle={() => setFreeModal(false)}
      />
      <Content>
        <Cover>
          <ContentImage
            style={{ backgroundImage: `url(${cover})` }}
          >
            <Info>
              <Description>{description}</Description>
              <ClassesLengthBadge length={courseModules.length} />
              <ClassProgress percentage={executed_percent} />
            </Info>
          </ContentImage>
        </Cover>
        <AccordionContainer>
          {
            courseModules?.map((item: any) => (
              <Accordion
                key={item.id}
                title={item.name}
              >
                {
                  item?.courseLectures.map((activity: any) => (
                    <ListContainer
                      key={activity.id}
                      onClick={() => openClass(activity)}
                    >
                      <Thumb>
                        <ContainerImgThumb>
                          <img src={cover} alt="" />
                        </ContainerImgThumb>
                        <p>
                          {activity.name}
                          <br />
                          <span>{format(addSeconds(new Date(0), activity.duration), 'mm:ss')}</span>
                        </p>
                      </Thumb>

                      <span>
                        {
                          (isFree && !freeClasses.includes(activity.name)) || (isSubscriptionAfterRuleDate && hiddenClassesBasic.includes(internal_name))
                            ? <AiFillLock color={theme.colors.title} size="18" />
                            : <img src={activity.executed_status === null ? icoCheck1 : icoCheck2} alt="Status" />
                        }
                      </span>

                    </ListContainer>
                  ))
                }
              </Accordion>
            ))
          }
        </AccordionContainer>
      </Content>

    </Container>
  );
}

export default ClassesCover;
